import AppService from "./app.service";

const DasboardService = () => {
  return Object.freeze({
    getCohortParticipantProgressStatusPercentageByAccount: async (accId) => {
      return await AppService.get(accId, "dashboard/cohortProgressStatus");
    },
    getPrePostSimFeedbackRatingQuestionsAverageByAccount: async (accId) => {
      return await AppService.get(accId, "dashboard/ratingFeedbackAverages");
    },
    getWellnessSurveyRatingQuestionsAverageByAccount: async (requestData) => {
      return await AppService.submit(
        requestData,
        "dashboard/wellness-survey-average"
      );
    },
    getJobConfidenceSurveyRatingQuestionsAverageByAccount: async (
      requestData
    ) => {
      return await AppService.submit(
        requestData,
        "dashboard/jobConfidence-survey-average"
      );
    },
    getWellnessSurveyQ6YesNoPercentage: async (requestData) => {
      return await AppService.submit(
        requestData,
        "dashboard/wellness-survey-percentage"
      );
    },
    getClientAISummaryByAccount: async (accId) => {
      return await AppService.get(accId, "dashboard/clientAiSummary");
    },
  });
};

export default DasboardService;
